import { Expose, Type } from '@nts/std/serialization';
import { AvailableLayoutDto } from "./available-layout-dto";
import type { AvailableLayoutDtoInterface, AvailableLayoutsInfoDtoInterface } from '@nts/std/interfaces';

export class AvailableLayoutsInfoDto implements AvailableLayoutsInfoDtoInterface {

    constructor() {
        this.availableLayouts = [];
    }

    @Expose()
    @Type(() => AvailableLayoutDto)
    availableLayouts: AvailableLayoutDtoInterface[];

}

